<script>
import dayjs from 'dayjs';
import {
  pageTitleMixin,
  prefetchDataMixin,
} from '@ubic/vue-mixins';
import { permissions } from '@/constants';
import ErrorAccessDenied from '@/components/ErrorAccessDenied';
import DateRangeSelect from '@/components/DateRangeSelect';
import WorkerProjects from './components/WorkerProjects';
import WorkerProjectsHistory from './components/WorkerProjectsHistory';
import { colorsProject } from './constants';
import service from './service';

export default {
  name: 'WorkerStatistic',
  pageTitle: 'Статистика по сотруднику',
  async prefetchData () {
    const { id } = this.$route.params;

    if (!this.hasReadPermission) {
      return;
    }

    if (!id) {
      this.$router.replace('/');
    }

    this.filter = {
      ...this.filter,
      ...this.$route.query,
    };

    this.isFetching = true;

    this.worker = await service.getWorkerById(id);

    this.isFetching = false;
  },
  mixins: [
    pageTitleMixin,
    prefetchDataMixin,
  ],
  data () {
    return {
      isFetching: false,
      worker: {},
      statistics: {
        total: 0,
        dateRange: [],
        projects: [],
      },

      filter: {
        minDate: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
        maxDate: dayjs().format('YYYY-MM-DD'),
      },
    };
  },
  computed: {
    hasReadPermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.WORKER_READ);
    },
    id () { return this.$route.params.id; },
    mapColors () {
      const colorsCount = colorsProject.length;

      return this.statistics.projects.reduce((acc, project, i) => ({
        ...acc,
        [project.id]: colorsProject[i % colorsCount],
      }), {});
    },
  },
  watch: {
    filter: {
      immediate: true,
      async handler () {
        if (!this.hasReadPermission) {
          return;
        }

        const { id, filter } = this;

        this.statistics = await service.getWorkerStatistics(id, filter);
      },
    },
  },
  methods: {
    handleDateRangeChange (dates) {
      this.filter = {
        ...this.filter,
        ...dates,
      };

      this.updateQueryString();
    },
    updateQueryString () {
      this.$router.replace({
        ...this.$route,
        query: { ...this.filter },
      });
    },
  },
  render () {
    if (!this.hasReadPermission) {
      return (
        <ErrorAccessDenied />
      );
    }

    if (this.isFetching) {
      return <u-spinner />;
    }

    const { worker, $style, filter } = this;

    return (
      <div>
        <header class="page-header">
          <u-title>
            <span class={$style.title}>
              {worker.name}
            </span>
            <span slot="sub">
              &nbsp;
              статистика
            </span>
          </u-title>
          <DateRangeSelect
            value={filter}
            onChange={this.handleDateRangeChange}
          />
        </header>

        <section>
          <WorkerProjectsHistory
            mapColors={this.mapColors}
            dateRange={this.statistics.dateRange || []}
            projects={this.statistics.projects || []}
          />
        </section>

        <section>
          <u-title level="2">
            Проекты
          </u-title>

          <WorkerProjects
            totalHours={this.statistics.total || 0}
            projects={this.statistics.projects || []}
            mapColors={this.mapColors}
          />
        </section>
      </div>
    );
  },
};
</script>

<style lang="scss" module>
.title {
  text-transform: none;
}

.row {
  display: flex;
  margin: 0 -1em;
}

.col {
  display: flex;
  flex-direction: column;
  padding: 0 1em;
  width: 50%;
}
</style>
